// extracted by mini-css-extract-plugin
export var actionBtn = "landing-slider-module--action-btn--lIP7x";
export var active = "landing-slider-module--active--kpBBj";
export var flexContainer = "landing-slider-module--flex-container--9s4-u";
export var image = "landing-slider-module--image--K7vvY";
export var landingSlider = "landing-slider-module--landing-slider--nCcVj";
export var landingSliderContainer = "landing-slider-module--landing-slider-container--62uGU";
export var pagination = "landing-slider-module--pagination--0WIwn";
export var paginationBullet = "landing-slider-module--pagination-bullet--7A3HO";
export var slide = "landing-slider-module--slide--qaXW3";